import { FormControl, MenuItem, Select, ListSubheader } from "@mui/material";
import { SxProps, Theme } from "@mui/material";
import { contentPlaceHolderTypes, PlaceHolderTypes } from "constants/PlaceholderTypes";

interface PlaceHolderSelectProps {
  type: PlaceHolderTypes;
  value: string;
  disabled?: boolean;
  onChange: (e: any) => void;
  plantProductsCount?: number;
  hideKeys?: string[];
  sx?: SxProps<Theme>;
}
export default function PlaceHolderSelect({
  type,
  value,
  onChange,
  plantProductsCount = 0,
  hideKeys = [],
  sx,
}: PlaceHolderSelectProps) {
  const placeHolder = contentPlaceHolderTypes[type];
  if (!placeHolder) {
    return null;
  }

  return (
    <FormControl sx={{ m: "1", minWidth: 200, ...(sx as object) }}>
      <Select
        displayEmpty
        onChange={onChange}
        value={""}
        sx={{ minWidth: "100%", minHeight: "40px" }}
        autoWidth
      >
        <MenuItem value="" disabled>
          Placeholders
        </MenuItem>
        {Object.keys(placeHolder).map((type) => {
          return [
            <ListSubheader key={type}>{type.replace(/([A-Z]{1})/g, " $1").trim()}</ListSubheader>,
            Object.keys(placeHolder[type])
              ?.filter((k) => {
                // Hide original application_rate and application_rate_inches when we have plant products
                if (type === "ProposalProduct" && plantProductsCount > 0) {
                  return k !== "application_rate" && k !== "application_rate_inches";
                }
                return !hideKeys.includes(k);
              })
              .map((k, i) => (
                <MenuItem key={i} value={`{{${k}}}`}>
                  {placeHolder[type][k]}
                </MenuItem>
              )),
            type === "ProposalProduct" &&
              plantProductsCount > 0 &&
              Array.from({ length: plantProductsCount }, (_, i) => [
                <MenuItem key={`application-rate-${i}`} value={`{{application_rate,${i + 1}}}`}>
                  Application Rate {i + 1}
                </MenuItem>,
                <MenuItem
                  key={`application-rate-inches-${i}`}
                  value={`{{application_rate_inches,${i + 1}}}`}
                >
                  Application Rate Inches {i + 1}
                </MenuItem>,
              ]),
          ];
        })}
      </Select>
    </FormControl>
  );
}
